<div class="page-wrapper">
    <div class="overview-container">
        <ng-container *ngIf="!isReceivingData">
            <div class="no-alarms-wrapper">
                <mat-icon
                    class="no-alarms-icon"
                    svgIcon="system-status-disconnected"
                />
                <div class="no-alarms-title">
                    {{
                        "system-status.overview.disconnected.title" | translate
                    }}
                </div>
                <div class="no-alarms-subtitle">
                    {{
                        "system-status.overview.disconnected.subtitle"
                            | translate
                    }}
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="isReceivingData">
            <div
                class="overview-wrapper"
                *ngIf="
                    getAlarmCounts(systemStatusData) > 0;
                    else noAlarmsContainer
                "
            >
                <div class="title">
                    {{ "system-status.overview.system-errors" | translate }}
                </div>
                <div class="errors-container">
                    <app-overview-system-error-indicator
                        [systemErrors]="systemErrors"
                        (onPageSelected)="openSelectedPage($event)"
                    >
                    </app-overview-system-error-indicator>
                </div>
            </div>
        </ng-container>
    </div>
    <div class="pages-container">
        <div class="page-status-row">
            <div class="page-status-container">
                <app-page-status-indicator
                    [isReceivingData]="isReceivingData"
                    [numberOfAlarms]="getAlarmCounts(systemStatusData.eap)"
                    [pageItems]="systemStatusData.eap.length"
                    [pageTitle]="'system-status.page-title.eap'"
                    (click)="openSelectedPage('eap')"
                >
                </app-page-status-indicator>
            </div>
            <div class="page-status-container">
                <app-page-status-indicator
                    [isReceivingData]="isReceivingData"
                    [numberOfAlarms]="getAlarmCounts(systemStatusData.ops)"
                    [pageItems]="systemStatusData.ops.length"
                    [pageTitle]="'system-status.page-title.ops'"
                    (click)="openSelectedPage('ops')"
                >
                </app-page-status-indicator>
            </div>
        </div>
        <div class="page-status-row">
            <div class="page-status-container">
                <app-page-status-indicator
                    [isReceivingData]="isReceivingData"
                    [numberOfAlarms]="getAlarmCounts(systemStatusData.fcu)"
                    [pageItems]="systemStatusData.fcu.length"
                    [pageTitle]="'system-status.page-title.fcu'"
                    (click)="openSelectedPage('fcu')"
                >
                </app-page-status-indicator>
            </div>
        </div>
        <div class="page-status-row">
            <div class="page-status-container">
                <app-page-status-indicator
                    [isReceivingData]="isReceivingData"
                    [numberOfAlarms]="getAlarmCounts(systemStatusData.comms)"
                    [pageItems]="systemStatusData.comms.length"
                    [pageTitle]="'system-status.page-title.comms.long'"
                    (click)="openSelectedPage('comms')"
                >
                </app-page-status-indicator>
            </div>
            <div class="page-status-container">
                <app-page-status-indicator
                    [isReceivingData]="isReceivingData"
                    [numberOfAlarms]="getAlarmCounts(systemStatusData.printers)"
                    [pageItems]="systemStatusData.printers.length"
                    [pageTitle]="'system-status.page-title.printers'"
                    (click)="openSelectedPage('printers')"
                >
                </app-page-status-indicator>
            </div>
        </div>
    </div>
</div>

<ng-template #noAlarmsContainer>
    <div class="no-alarms-wrapper">
        <mat-icon class="no-alarms-icon" svgIcon="no-alarms-icon"> </mat-icon>
        <div class="no-alarms-title">
            {{ "system-status.overview.no-alarms.title" | translate }}
        </div>
        <div class="no-alarms-subtitle">
            {{ "system-status.overview.no-alarms.subtitle" | translate }}
        </div>
    </div>
</ng-template>
